import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import WizardLayout from "../../components/WizardLayout";
import useWizardSteps from "../../hooks/useWizardSteps";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import { ReactComponent as ChevronDownIcon } from "../../img/caret.svg";
import api from "../../api";
import WizardNavigation from "../../components/WizardNavigation";
import { getInsuranceLocalInfo } from "../../utils";
import { setActivity } from "../../redux/activityData";
import { setActivityName } from "../../redux/activityNameData";
import { fetchUserData } from "../../redux/user";

const useStyles = makeStyles((theme) => ({
  container: {
    borderTop: "2px solid #cfdae2",
    position: "relative",
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
      marginTop: 30,
    },
  },
  label: {
    fontSize: "20px",
    color: "#717271",
    top: "-15px",
  },
  labelSmall: {
    fontSize: "20px",
    color: "#717271",
    top: "-15px",
    [theme.breakpoints.up("lg")]: {
      alignSelf: "flex-end",
    },
  },
  formControl: {
    marginTop: "24px",
    padding: "0",
    width: "80%",
    marginLeft: "20px",
    marginRight: "20px",
  },
  input: {
    color: "#323232",
    fontSize: "16px",
  },
  inputSmall: {
    color: "#323232",
    fontSize: "16px",
  },
  selectIcon: {
    position: "absolute",
    left: "95%",
    top: "5px",
  },
  error: {
    color: "#FF0000",
  },
}));

export default function Activity(props) {
  const history = useHistory();
  const { token, insuranceName } = useSelector(
    ({ user, dismiss, auth, insurances }) => ({
      contactDetails: user.contactDetails,
      dismiss,
      token: auth.token,
      insuranceName: insurances.selected.insuranceName,
      insuranceProductId: insurances.selected.insuranceProductId,
    })
  );
  const [activities, setActivities] = useState([]);
  const [selected, setSelected] = useState();
  const [selected2, setSelected2] = useState();

  const classes = useStyles();
  const dispatch = useDispatch();
  const insuranceInfo = getInsuranceLocalInfo(insuranceName);

  const suggestion = (
    <span>
      <b>Elegí la actividad</b> que mejor describa tu negocio
    </span>
  );

  useEffect(() => {
    const getActivities = async () => {
      try {
        const { data } = await api.get(
          // code 1999 brings activities
          "/seguros/informacion/adicional/relacional/ch/PDS?code=1999",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setActivities(
          data.additionalDataBlocks[0].additionalDataBlock.additionalDatas
        );
        dispatch(fetchUserData());
      } catch (e) {
        console.log(e);
      }
    };

    getActivities();
  }, []);

  const nextAction = () => {
    dispatch(setActivity({ selected }));
    dispatch(setActivityName({ selected2 }));
    history.push(`${insuranceInfo.url}/planes`);
  };

  const [show, setShow] = useState(true);

  const emptyAction = () => {
    setShow(!show);
  };

  const handleChange = (e) => {
    setSelected(e.target.value.code);
    setSelected2(e.target.value.description);
  };

  const [activeStep] = useWizardSteps(1);

  return (
    <div className='dismiss-container'>
      {" "}
      <WizardLayout
        activeStep={activeStep}
        suggestion={suggestion}
        //withBadge
        withTerms
        showNextButton={false}
        withBadge={false}
      >
        <FormControl fullWidth classes={{ root: classes.formControl }}>
          <InputLabel
            shrink
            focused={false}
            htmlFor='activity'
            classes={{ root: classes.label }}
          >
            Seleccione una actividad
          </InputLabel>
          <Select
            id='activity'
            name='activity'
            onChange={handleChange}
            value={selected}
            IconComponent={() => (
              <ChevronDownIcon className={classes.selectIcon} />
            )}
          >
            {activities.map((item, key) => {
              return (
                <MenuItem key={key} value={item.additionalData}>
                  {item.additionalData.description}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText classes={{ root: classes.error }}></FormHelperText>
        </FormControl>
        <WizardNavigation nextAction={selected ? nextAction : emptyAction} />
        {show ? (
          <div></div>
        ) : (
          <div style={{ color: "red", marginLeft: "auto" }}>
            Es necesario que elijas una actividad para continuar
          </div>
        )}
      </WizardLayout>
    </div>
  );
}
